<template>
  <card class="card">
    <div class="row">
      <div class="col-md-4" style="text-align: right;">
        <base-button class="clock-button" size="lg" simple block type="success" @click="create">Create a ticket</base-button>
      </div>
      <div class="col-md-4" style="text-align: right;">
        <base-button class="clock-button" size="lg" simple block type="warning" @click="filter">Get tickets</base-button>
      </div>
      <div class="col-md-4" style="text-align: right;">
        <base-button class="clock-button" size="lg" simple block type="primary" @click="openFilter = !openFilter">
          Filter
          <i v-if="openFilter" class="tim-icons icon-minimal-up"></i>
          <i v-else class="tim-icons icon-minimal-down"></i>
        </base-button>
      </div>
    </div>
    <div class="row" v-if="openFilter">
      <div class="col-md-12">
        <div class="row">
          <base-input class="col-md-3 col-lg-3"
                      label="# Ticket"
                      v-model="ticket_id"
                      type="number"
                      placeholder="Number of ticket"></base-input>
          <base-input class="col-md-3 col-lg-3"
                      label="Author">
            <select class="form-control"
                    v-model="employee_id_from">
              <option value="0" disabled>Choose employee</option>
              <option v-for="employee in employees" :value="employee.employee_id" :key="employee.employee_id">{{employee.first_name + ' ' + employee.last_name}}</option>
            </select>
          </base-input>
          <base-input class="col-md-3 col-lg-3" label="Responsible Employee">
          <select class="form-control"
                  v-model="employee_id_to">
            <option value="0" disabled>Choose employee</option>
            <option v-for="employee in employees" :value="employee.employee_id" :key="employee.employee_id">{{employee.first_name + ' ' + employee.last_name}}</option>
          </select>
          </base-input>
          <base-input class="col-md-3 col-lg-3" label="Priority">
            <select
              v-model="priority"
              class="form-control">
              <option value="" disabled>Choose one</option>
              <option value="danger"  style="background-color: #f5365c; color: white">Danger </option>
              <option value="warning" style="background-color: #f96332; color: white">Warning</option>
              <option value="normal"  style="background-color: #40b27e; color: white">Normal </option>
              <option value="not-important" style="background-color: #3b5998; color: white">Not important</option>
            </select>
          </base-input>
        </div>
        <div class="row" style="margin-top: 15px;">
          <base-input class="col-lg-2 col-md-3 col-4" label="Deleted">
            <base-radio name="empty" class="mb-3" v-model="radioValue1">
              Ignore this
            </base-radio>
            <base-radio name="True" class="mb-3" v-model="radioValue1">
              Yes
            </base-radio>
            <base-radio name="False" class="mb-3" v-model="radioValue1">
              No
            </base-radio>
          </base-input>
          <base-input class="col-lg-2 col-md-3 col-4" label="Submitted">
            <base-radio name="empty" class="mb-3" v-model="radioValue2">
              Ignore this
            </base-radio>
            <base-radio name="True" class="mb-3" v-model="radioValue2">
              Yes
            </base-radio>
            <base-radio name="False" class="mb-3" v-model="radioValue2">
              No
            </base-radio>
          </base-input>
          <base-input class="col-lg-2 col-md-3 col-4" label="Confirmed">
            <base-radio name="empty" class="mb-3" v-model="radioValue3">
              Ignore this
            </base-radio>
            <base-radio name="True" class="mb-3" v-model="radioValue3">
              Yes
            </base-radio>
            <base-radio name="False" class="mb-3" v-model="radioValue3">
              No
            </base-radio>
          </base-input>
          <base-input class="col-lg-2 col-md-3 col-4" label="Read">
            <base-radio name="empty" class="mb-3" v-model="radioValue4">
              Ignore this
            </base-radio>
            <base-radio name="True" class="mb-3" v-model="radioValue4">
              Yes
            </base-radio>
            <base-radio name="False" class="mb-3" v-model="radioValue4">
              No
            </base-radio>
          </base-input>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
    export default {
      name: "TicketsFilter",
      props:['employees'],
      data(){
        return{
          ticket_id : "",
          employee_id_from : "0",
          employee_id_to : "0",
          radioValue1: 'False',
          radioValue2: 'empty',
          radioValue3: 'empty',
          radioValue4: 'empty',
          priority : "",
          openFilter: false,
        }
      },
      methods:{
        create(){
          this.$router.push('/ticket-details/?ticket-id=0');
        },
        filter(){
          let url = '#/tickets/?';
          const params = {};
          if (this.ticket_id !== "") {params['ticket_id'] = this.ticket_id;                       url = url + 'ticket_id='        + this.ticket_id + '&';}
          if (this.employee_id_from !== "0") {params['employee_id_from'] = this.employee_id_from; url = url + 'employee_id_from=' + this.employee_id_from + '&';}
          if (this.employee_id_to !== "0")   {params['employee_id_to'] = this.employee_id_to;     url = url + 'employee_id_to='   + this.employee_id_to + '&';}
          if (this.radioValue1 !== "empty")  {params['deleted'] = this.radioValue1;               url = url + 'deleted='          + this.radioValue1 + '&';}
          if (this.radioValue2 !== "empty")  {params['done'] = this.radioValue2;                  url = url + 'done='             + this.radioValue2 + '&';}
          if (this.radioValue3 !== "empty")  {params['confirmed'] = this.radioValue3;             url = url + 'confirmed='        + this.radioValue3 + '&';}
          if (this.radioValue4 !== "empty")  {params['is_read'] = this.radioValue4;               url = url + 'is_read='          + this.radioValue4 + '&';}
          url = url.substring(0, url.length - 1);
          window.history.pushState("", "", url);
          this.$emit('get-tickets', params);
        },
      },
    }
</script>

<style scoped>

</style>
